<template>
  <div 
    class="magnetic" 
    :class="{ debug: testing }" 
    :style="{ padding: isMobile ? '0px' : magnetPadding, borderColor: buttonColor }" 
    ref="magneticRef" 
    @mousemove="moveMagnet"
    @mouseout="resetPosition"
  >
    <button
      type="button"
      class="button"
      :style="{ width: buttonSize, height: buttonSize, color: buttonColor, borderColor: buttonColor }"
    >
      {{ buttonText }}
    </button>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, reactive } from 'vue';
import gsap from 'gsap'; // Make sure to import GSAP library
import { isMobile } from 'mobile-device-detect';

export default {
  props: {
    testing: {
      type: Boolean,
      default: false,
    },
    magnetPadding: {
      type: String,
      default: '120px',
    },
    magnetStrength: {
      type: Number,
      default: 100,
    },
    magnetXOffset: {
      type: Number,
      default: 0,
    },
    magnetYOffset: {
      type: Number,
      default: 0,
    },
    buttonSize: {
      type: String,
      default: '100px',
    },
    buttonText: {
      type: String,
      default: 'View',
    },
    buttonColor: {
      type: String,
      default: 'white',
    },
  },
  setup(props) {
    const magneticRef = ref(null);
    const strength = props.magnetStrength;

    const moveMagnet = (event) => {
      const magnetButton = magneticRef.value;
      const bounding = magnetButton.getBoundingClientRect();

      gsap.to(magnetButton, {
        duration: 1,
        x: ((((event.clientX - bounding.left) / magnetButton.offsetWidth) - 0.5) * strength) + props.magnetXOffset,
        y: ((((event.clientY - bounding.top) / magnetButton.offsetHeight) - 0.5) * strength) + props.magnetXOffset,
        ease: 'power4.out',
      });
    };

    const resetPosition = (event) => {
      gsap.to(event.currentTarget, { duration: 1, x: props.magnetXOffset, y: props.magnetYOffset, ease: 'power4.out' });
    };

    onMounted(() => {
      if(!isMobile){
        const magnetButton = magneticRef.value;
        gsap.set(magnetButton, { x: props.magnetXOffset, y: props.magnetYOffset });
        magnetButton.addEventListener('mousemove', moveMagnet);
        magnetButton.addEventListener('mouseout', resetPosition);
      }
    });

    onUnmounted(() => {
      if(!isMobile){
        const magnetButton = magneticRef.value;
        if (magnet) {
          magnetButton.removeEventListener('mousemove', moveMagnet);
          magnetButton.removeEventListener('mouseout', resetPosition);
        }
      }
    });

    return {
      magneticRef,
      moveMagnet,
      resetPosition,
      isMobile,
    };
  },
};
</script>

<style>
.magnetic {
  position: relative;
  display: inline-block;
  border-radius: 50%;
  &.debug {
    border: 1px dashed rgba(255, 255, 255, 0.3);
  }
}

.button {
  display: block;
  border: 1px solid white;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  font-size: 1.9rem;
  cursor: pointer;
  background: transparent;
  color: white;
  font-family: var(--fontSerifItSb);
  /* pointer-events: none; */
}
</style>
